import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { ButtonContinue } from '../../common/Button/ButtonContinue';

type MessageDialogProps = {
  title: string;
  messageToDisplay: string;
  showDialog: boolean;
  onCloseModal: () => void;
  brandName: string;
};

const MessageDialog = ({
  title,
  messageToDisplay,
  showDialog,
  onCloseModal,
  brandName
}: MessageDialogProps): JSX.Element => {
  const onClickClose = () => {
    onCloseModal();
  };

  const modalClass = 'modal-dialog-' + brandName;

  return (
    <Modal
      role={modalClass}
      className={`insurance-${brandName}`}
      isOpen={showDialog}
      toggle={onClickClose}>
      <ModalHeader toggle={onClickClose}>{title}</ModalHeader>
      <ModalBody>
        <div className='text-uppercase'>{messageToDisplay}</div>
      </ModalBody>
      <ModalFooter>
        <ButtonContinue
          name='btn-close'
          text='Close'
          onClick={onClickClose}
          additionalClassNames='btn-cancel'
        />
      </ModalFooter>
    </Modal>
  );
};

export default MessageDialog;
